module.exports = __webpack_public_path__ + "static/media/011.cf5fcbf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/011.jpg
// module id = 518
// module chunks = 0